import { render } from "./EventsVESTableActionsCell.vue?vue&type=template&id=39065b80&scoped=true&ts=true"
import script from "./EventsVESTableActionsCell.vue?vue&type=script&lang=ts"
export * from "./EventsVESTableActionsCell.vue?vue&type=script&lang=ts"

import "./EventsVESTableActionsCell.vue?vue&type=style&index=0&id=39065b80&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39065b80"]])

export default __exports__